import DeleteEntryConfirmDialog from './DeleteEntryConfirmDialog'

export default DeleteEntryConfirmDialog

export const DIALOG_NAME = 'onboarding/DELETE_ENTRY_CONFIRM_DIALOG'
